// extracted by mini-css-extract-plugin
export var wrap = "yours-module--wrap--e95f3";
export var yours = "yours-module--yours--80ad3";